import * as c2pService from '@api/company-person';
import { AppBarTitle } from '@components/app-bar-title';
import { PageLoading } from '@components/page-loading';
import { useRequest } from '@lib/common';
import { Grid, IconButton } from '@material-ui/core';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { C3EditForm } from './form';
import { getC3RelationById, updateC3Relation } from '@api/c3';

export default function EditC3Relation() {
  const { c3_rel_id } = useParams<{ c3_rel_id: string }>();
  
  const { loading: c3Loading, result: c3Data, error: c3Error } = useRequest(
    () => getC3RelationById(c3_rel_id),
    [c3_rel_id]
);
  let search = window.location.search;
  let params = new URLSearchParams(search);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();

  const redirectToSearch = useCallback(() => {
    if (history.location.search) {
      const returnTo = new URLSearchParams(history.location.search).get('returnTo');
      if (returnTo) {
        history.push(returnTo);
        return;
      }
    }
    history.push('/c3-page/search');
  }, [history]);

  // Form Actions
  const saveDeal = useCallback(
    companymapping => {
      const infoNotification = enqueueSnackbar('Please wait Saving C3 Relation', {
        variant: 'info',
      });
      return updateC3Relation(c3_rel_id, companymapping).subscribe({
        next: () => {
          enqueueSnackbar('C3 Relation Saved Successfully!', { variant: 'success' });
          redirectToSearch();
        },
        error: err => {
          const errMsg = err?.response?.data?.error;
          enqueueSnackbar(`Error Saving C3 Relation (${errMsg ? errMsg : err})`, {
            variant: 'error',
          });
        },
        complete: () => closeSnackbar(infoNotification),
      });
    },
    [redirectToSearch]
  );

  if (!c3_rel_id) {
    return <Redirect to="/c3-page/search" />;
  }

  return (
    <div>
      <AppBarTitle>
        <Grid container spacing={3}>
          <Grid item style={{ alignSelf: 'center' }}>
            <IconButton onClick={null} color="inherit" edge="start">
              <SpellcheckRoundedIcon />
            </IconButton>
            Review C3 Relation
          </Grid>
        </Grid>
      </AppBarTitle>
      {c3Loading ? (
        <PageLoading>Loading C3 to edit...</PageLoading>
      ) : (
        <C3EditForm c3Data={c3Data} onSubmit={saveDeal} redirectToSearch={redirectToSearch} c3RelationId = {c3_rel_id}/>
      )}
    </div>
  );
}